import _ from 'lodash'

import type { Group, RowWithGroupingMetadata } from '@/components/lemmala-design-system/table/types'

/** Flattens groups into display rows with grouping metadata (parent → header → children). */
export function buildGroupedRows<T extends { id: string }>(
  groups: Group<T>[],
  expandedGroups: Set<string>,
) {
  return _.flatMap(groups, ({ parent, children }) => {
    if (children.length === 0) {
      return [parent]
    }

    const isExpanded = expandedGroups.has(parent.id)

    return [
      { ...parent, isGroupParent: true, groupId: parent.id },
      {
        ...parent,
        id: `${parent.id}-group-header`,
        isGroupHeader: true,
        isExpanded,
        groupChildCount: children.length,
        groupId: parent.id,
      } as RowWithGroupingMetadata<T>,
      ...(isExpanded
        ? children.map((child) => ({ ...child, isGroupChild: true, groupId: parent.id }))
        : []),
    ]
  })
}
